import React from 'react'
let PropTypes = React.PropTypes
// NOTIFICACIONES
import ReactNotify from 'react-notify'
import * as ReactNotifyCSS from '../../../shared/ReactNotify/ReactNotify.css'
// MOMENT
import moment from 'moment'
moment.locale('es')
// CALENDARIO
import SelectRange from '../../../components/shared/SelectRange.jsx'
// API
import api from '../../../apiClient/v1'
// COMPONENTES
import { TablaFacturas } from './TablaFacturas.jsx'
const format = 'YYYY-MM-DD'


export class MisFacturas extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            fechaInicialSeleccionada: moment().startOf('month'),
            fechaFinalSeleccionada: moment().endOf('week'),
            facturasFiltradas: []
        }
        this.ajaxErrorHandler = (errorTitle)=>{
            return (err)=>{
                if(err.status==500)
                    return this.refs.notificator.error("Error crítico en el servidor", "Contáctese con el departamento de informática.", 4*1000);
                // en otro error, buscar el cuerpo del mensaje
                let msgs = _.values(err.data).join('. ')
                console.log(err)
                console.log(errorTitle, err.data)
                this.refs.notificator.error(errorTitle, msgs, 4*1000);
            }
        }
        this.buscarFacturas = ()=>{
            let fechaInicio = this.state.fechaInicialSeleccionada.format(format)
            let fechaFin = this.state.fechaFinalSeleccionada.format(format)
            api.facturacion(this.props.cliente).disponiblesCliente(fechaInicio, fechaFin)
                .then(facturas=>{
                    this.setState({facturasFiltradas: facturas})
                })
        }
        this.onSelectRangoChanged = (momentumFechaInicio, momentumFechaFinal)=>{
            this.setState({
                fechaInicialSeleccionada: momentumFechaInicio,
                fechaFinalSeleccionada: momentumFechaFinal
            }, ()=>{
                this.buscarFacturas()

            })
        }
    }
    componentWillMount(){
        this.buscarFacturas()
    }
    render(){
        return (
            <div className={'container-fluid'}>
                <div className={'row'}>
                    <ReactNotify ref='notificator' className={ReactNotifyCSS}/>
                    {/* SELECTOR UN RANGO DE FECHAS */}
                    <div className={'col-sm-3 form-group '}>
                        <label className="control-label">Rango de Fecha</label>
                        <SelectRange
                            startDateSelected = {this.state.fechaInicialSeleccionada}
                            endDateSelected = {this.state.fechaFinalSeleccionada}
                            onInit={()=>{console.log("on init")}}
                            onRangeSelected = {this.onSelectRangoChanged.bind(this)}
                        />
                    </div>
                </div>
                <TablaFacturas
                    facturas ={this.state.facturasFiltradas}
                />
            </div>
        )
    }
}
MisFacturas.propTypes = {
    cliente: PropTypes.number
}


// WEBPACK FOOTER //
// ./frontEnd/facturacion/lista-facturas/cliente-fcv/MisFacturas.jsx